import { formatDateTimeInternal } from '@core/_utils/date.utils';
import { format } from '@core/_utils/date.utils';
import {
    getFileExt,
    isInArrayKey,
    returnEmpty,
    decodeUtf8,
    allowConvert,
    getDateInternal,
} from '@core/_utils/tools.utils';
import { ext_Tiff, ext_Images, ext_Text, ext_Calc, ext_Show, ext_Mail, reqBas, ext_Pdf, AvailableModeViewDoc } from '@documalis/_const/const';

export function formatRequestVersion(aDocId, aAction) {
    let wRequest;
    wRequest = {
        Docid: aDocId,
        UpdateList: {
            UpdateActivityDate: 'true',
            Version: {
                ...aAction,
            },
        },
    };
    return wRequest;
}


export function getDisplay(aVariableList) {
    let wRes = false;
    for (const item of aVariableList) {
        if (item.system === 'false' || item.visible === 1) {
            wRes = true;
            break;
        }
    }
    return wRes;
}

export function bskPropertyMail(aData) {
    return {
        bsk_docdate: getDateInternal(aData.bsk_docdate),
        bsk_docstatus: aData.bsk_docstatus,
        bsk_wkfid: '',
        bsk_mailaction: aData.bsk_mailaction,
        bsk_maillimit: getDateInternal(aData.bsk_maillimit),
        bsk_mailurgent: aData.bsk_mailurgent,
        bsk_mailconf: aData.bsk_mailconf,
    };
}

export function bskProperty(aData) {
    return {
        bsk_docdate: getDateInternal(aData.bsk_docdate),
        bsk_docstatus: aData.bsk_docstatus,
        bsk_wkfid: '',
        bsk_mailaction: '',
        bsk_maillimit: '',
        bsk_mailurgent: '',
        bsk_mailconf: '',
    };
}

export function bskPropertyAction(aData) {
    return {
        bsk_docdate: getDateInternal(aData.bsk_docdate),
        bsk_docstatus: aData.bsk_docstatus,
        bsk_wkfid: aData.bsk_wkfid,
        bsk_mailaction: '',
        bsk_maillimit: '',
        bsk_mailurgent: '',
        bsk_mailconf: '',
    };
}

export function setActionMail(aInfosMail, aCurrentSelectedBsk) {
    let wDateLim = '';
    if (aInfosMail.mailLimit === true) {
        wDateLim = format(aInfosMail.dateLimit);
    }
    return {
        mailAction: aInfosMail.mailAction,
        status: aInfosMail.status,
        dstBasketName: aCurrentSelectedBsk.bskName,
        msgId: '',
        mailLimit: wDateLim,
        mailUrg: aInfosMail.mailUrgent,
        mailConf: aInfosMail.mailConf,
    };
}

export function atfAdd(aData, aDocAtf) {
    let wRes;
    let wAtf = new Object();
    let wListExt = [...ext_Tiff, ...ext_Images, ...ext_Text, ...ext_Calc, ...ext_Show, ...ext_Mail];
    let wListVisu = [...ext_Images, ...ext_Pdf, ...ext_Text, ...ext_Calc];
    let wfile = decodeUtf8(aData.atfFile.name);
    let wExt = getFileExt(wfile);
    wRes = isInArrayKey(wfile, aDocAtf, 'Name');
    if (wRes === undefined) {
        wAtf = {
            Extension: wExt,
            Name: wfile,
            Size: aData.atfFile.size,
            Type: '',
            name: wfile,
            value: '',
            ModifiedOn: formatDateTimeInternal(new Date()),
            allowCnv: allowConvert(wExt, wListExt),
            visu: allowConvert(wExt, wListVisu),
        };
        aDocAtf.push(wAtf);
    }
    return aDocAtf;
}

export function atfDel(aData, aDocAtf) {
    return (aDocAtf = aDocAtf.filter((item) => {
        return item.name !== aData.name;
    }));
}

export function atfRen(aData, aDocAtf) {
    for (let i = 0; i < aDocAtf.length; i++) {
        if (aDocAtf[i].Name === aData.oldAtfName) {
            aDocAtf[i].Name = aData.name;
            aDocAtf[i].name = aData.name;
            aDocAtf[i].Extension = getFileExt(aData.name);
            break;
        }
    }
    return aDocAtf;
}

export function setMenuImageBsk(aCurrentSelectedBsk, aRightService, aMenuImage, self) {
    AddTextPdf(aMenuImage, self);
    if (aRightService.typeAction.TPost === true) {
        addAnnot(aMenuImage, self);
    }
    if (aCurrentSelectedBsk.pdfSignPicture === true && aRightService.typeAction.TSign === true) {
        addGraphSign(aMenuImage, self);
    }
    if (Array.isArray(aCurrentSelectedBsk.pdfStampList) === true) {
        if (aCurrentSelectedBsk.pdfStampList.length !== 0) {
            aCurrentSelectedBsk.pdfStampList.map((item) => {
                if (item.Active === true) {
                    addStamp(item, aMenuImage, self);
                }
            });
        }
    }
}

export function AddTextPdf(aMenuImage, self) {
    aMenuImage.push({
        label: self.translate.instant('AddTextPdf'),
        icon: 'icons8-modifier-la-propri-t-',
        command: (event) => {
            self.actionPdf('addtextpdf', null);
        },
    });
}

export function addAnnot(aMenuImage, self) {
    aMenuImage.push({
        label: self.translate.instant('Annot'),
        icon: 'icons8-comments',
        command: (event) => {
            self.actionPdf('annot', null);
        },
    });
}

export function addGraphSign(aMenuImage, self) {
    aMenuImage.push({
        label: self.translate.instant('Graphsign'),
        icon: 'icons8-signature',
        command: (event) => {
            self.actionPdf('graphsign', null);
        },
    });
}

export function addStamp(aItem, aMenuImage, self) {
    aMenuImage.push({
        label: aItem.Text,
        icon: 'icons8-stamp',
        command: (event) => {
            self.actionPdf('stamp', aItem);
        },
    });
}

export function setActionsGed(aRightService, aBtDocActionList, aSrchMode, self) {
    addRename(aRightService, aBtDocActionList, self);
    if (aRightService.typeAction.TDel && aSrchMode !== reqBas) {
        aBtDocActionList.push({
            call: self.goOnDelGed.bind(self),
            pTooltip: self.translate.instant('Del_Ged'),
            class: 'margin cust-width p-button-danger',
            icon: 'icons8-trash-can',
            disabled: false,
        });
    }

    addComAct(aRightService, aBtDocActionList, self);

    addVer(aRightService, aBtDocActionList, self);
}

export function addComAct(aRightService, aBtDocActionList, self) {
    if (aRightService.menuItem.TRBsk) {
        addTrans(aBtDocActionList, self);
    }

    addMail(aRightService, aBtDocActionList, self);
}

export function setActionsAtf(aRightService) {
    return {
        atfAllowAddFile: !aRightService.typeAction.TAtfAdd,
        atfAllowConvertPdf: !aRightService.typeAction.TAtfCnv,
        atfAllowDelete: !aRightService.typeAction.TAtfDel,
        atfAllowPrefixList: false,
        atfAllowRename: true,
        atfAllowSaveAs: true,
        atfRenaming: '',
    };
}

export function setActionsBsk(aCurrentSelectedBsk, aRightService, aBtDocActionList, self) {
    if (aCurrentSelectedBsk.bskType !== 'btAction' && aRightService.typeAction.TDel === true) {
        aBtDocActionList.push({
            call: self.goOnDel.bind(self),
            pTooltip: self.translate.instant('Del_Bsk'),
            class: 'margin cust-width p-button-danger',
            icon: 'icons8-trash-can',
            disabled: false,
        });
    }

    addComAct(aRightService, aBtDocActionList, self);

    if (aCurrentSelectedBsk.bskAllowSetRvf === true && aCurrentSelectedBsk.bskAllowCreateVersion === true) {
        addVer(aRightService, aBtDocActionList, self);
    }

    if (aCurrentSelectedBsk.bskComposition === true) {
        aBtDocActionList.push({
            call: self.goOnCompose.bind(self),
            pTooltip: self.translate.instant('Compo_Bsk'),
            class: 'margin cust-width',
            icon: 'pi pi-share-alt',
            disabled: false,
        });
    }
}

export function addNavigate(aBtDocActionList, self) {
    aBtDocActionList.push({
        call: self.goOnPreviousDoc.bind(self),
        pTooltip: self.translate.instant('Prev'),
        class: 'margin cust-width',
        icon: 'pi pi-chevron-left',
        disabled: false,
    });

    aBtDocActionList.push({
        call: self.goOnNextDoc.bind(self),
        pTooltip: self.translate.instant('Next'),
        class: 'margin cust-width',
        icon: 'pi pi-chevron-right',
        disabled: false,
    });
}

export function setTrackIdx(actionsList: { key?: number }[], self) {
    return actionsList.map((item, index) => ({
        ...item,
        key: index,
    }));
}

export function setLock(aCurrentLockUser, aCurrentUser, aBtDocActionList, self) {
    let wClass = '';
    wClass = getLockClass(aCurrentLockUser, aCurrentUser);

    aBtDocActionList.push({
        call: self.goOnLockUnlock.bind(self),
        pTooltip: self.translate.instant('Lock_Un'),
        class: wClass,
        icon: 'icons8-padlock-outline',
        disabled: false,
    });
}

export function getLockClass(aCurrentLockUser, aCurrentUser) {
    let wClass = '';
    if (aCurrentLockUser === '') {
        wClass = 'margin cust-width';
    }
    if (aCurrentLockUser === aCurrentUser) {
        wClass = 'margin cust-width p-button-success';
    }
    if (aCurrentLockUser !== aCurrentUser && aCurrentLockUser !== '') {
        wClass = 'margin cust-width p-button-danger';
    }
    return wClass;
}

export function addDwnlPdf(aRightService, aBtDocActionList, self) {
    if (aRightService.typeAction.TDlCpy) {
        aBtDocActionList.push({
            call: self.goOnDownload.bind(self, 'copy'),
            pTooltip: self.translate.instant('Copy_Dl'),
            class: 'margin cust-width',
            icon: 'icons8-export-pdf',
            disabled: false,
        });
    }
    if (aRightService.typeAction.TDlOri) {
        aBtDocActionList.push({
            call: self.goOnDownload.bind(self, 'orig'),
            pTooltip: self.translate.instant('Dl_Ori'),
            class: 'margin cust-width',
            icon: 'icons8-t-l-charger',
            disabled: false,
        });
    }
}

export function addRename(aRightService, aBtDocActionList, self) {
    if (aRightService.typeAction.TMov) {
        aBtDocActionList.push({
            call: self.goOnRenameDoc.bind(self),
            pTooltip: self.translate.instant('Ren_Doc'),
            class: 'margin cust-width',
            icon: 'icons8-rebaptiser',
            disabled: false,
        });
    }
}

export function addTrans(aBtDocActionList, self) {
    if (self.bskMode === false) {
        setAddTrans(aBtDocActionList, self);
    }
}

export function setAddTrans(aBtDocActionList, self) {
    aBtDocActionList.push({
        call: self.goOnTransGed.bind(self),
        pTooltip: self.translate.instant('Tr_Bsk'),
        class: 'margin cust-width',
        icon: 'icons8-send-package-2',
        disabled: false,
    });
}

export function addMail(aRightService, aBtDocActionList, self) {
    if (aRightService.typeAction.TMail) {
        aBtDocActionList.push({
            call: self.goOnSendMail.bind(self),
            pTooltip: self.translate.instant('Send_Email'),
            class: 'margin cust-width',
            icon: 'icons8-envoyer-des-email-de-masse',
            disabled: false,
        });
    }
}

export function addVer(aRightService, aBtDocActionList, self) {
    if (aRightService.typeAction.TVVer) {
        aBtDocActionList.push({
            call: self.goOnVer.bind(self),
            pTooltip: self.translate.instant('Version'),
            class: 'margin cust-width',
            icon: 'icons8-versions',
            disabled: false,
        });
    }
}

export function getModeViewDoc(aModeViewDoc) {
    let wIndex = -1;
    wIndex = AvailableModeViewDoc.findIndex((item) => item.value === aModeViewDoc);
    if (wIndex === -1) {
        wIndex = 1;
    }
    return wIndex; 
}

export function setModePdf(aBskMode, aCurrentSelectedBsk, aBtDocActionList, self) {
    if (aBskMode) {
        if (aCurrentSelectedBsk.bskRights.TGViewPdf) {
            addReadPdf(aBtDocActionList, self);
        } else {
            self.typeView = 2;
        }
    } else {
        addReadPdf(aBtDocActionList, self);
    }

    aBtDocActionList.push({
        call: self.goTypeView2.bind(self),
        pTooltip: self.translate.instant('Pic'),
        class: 'margin cust-width p-button-secondary',
        icon: 'icons8-image',
        disabled: false,
    });
}

export function addReadPdf(aBtDocActionList, self) {
    if (self.isDesktop === true) {
        aBtDocActionList.push({
            call: self.goTypeView0.bind(self),
            pTooltip: self.translate.instant('Read_Pdf'),
            class: 'margin cust-width p-button-secondary',
            icon: 'icons8-pdf-2',
            disabled: false,
        });
        aBtDocActionList.push({
            call: self.goTypeView3.bind(self),
            pTooltip: self.translate.instant('View_Pdf'),
            class: 'margin cust-width p-button-secondary',
            icon: 'pi pi-window-maximize',
            disabled: false,
        });
    } else {
        self.typeView = 2;
    }
    if (self.menuImage.length !== 0) {
        addActionPdf(aBtDocActionList, self);
    }
}

export function addActionPdf(aBtDocActionList, self) {
    aBtDocActionList.push({
        call: self.goTypeView1.bind(self),
        pTooltip: self.translate.instant('Act_Pdf'),
        class: 'margin cust-width p-button-secondary',
        icon: 'icons8-pdf-3',
        disabled: false,
    });
}

export function setBtModeView(aBtGridActionList, self) {
    aBtGridActionList.push({
        call: self.goGrid.bind(self),
        pTooltip: self.translate.instant('grid'),
        class: 'margin cust-width p-button-secondary',
        icon: 'icons8-data-grid',
        disabled: false,
    });
    aBtGridActionList.push({
        call: self.goThumb.bind(self, 160),
        pTooltip: self.translate.instant('thumb'),
        class: 'margin cust-width p-button-secondary',
        icon: 'icons8-grille-d-activit--2',
        disabled: false,
    });
    aBtGridActionList.push({
        call: self.goThumb.bind(self, 320),
        pTooltip: self.translate.instant('bthumb'),
        class: 'margin cust-width p-button-secondary',
        icon: 'icons8-grille-d-activit--2',
        disabled: false,
    });

    if (self.bskMode) {
        if (self.currentSelectedBsk.bskRights.TGViewPdf) {
            addSplit(aBtGridActionList, self);
        }
    } else {
        addSplit(aBtGridActionList, self);
    }

    aBtGridActionList.push({
        call: self.goDetail.bind(self),
        pTooltip: self.translate.instant('detail'),
        class: 'margin cust-width p-button-secondary',
        icon: 'icons8-visible',
        disabled: false,
    });
}

export function addSplit(aBtGridActionList, self) {
    if (self.isDesktop === true) {
        aBtGridActionList.push({
            call: self.goSplit.bind(self),
            pTooltip: self.translate.instant('split'),
            class: 'margin cust-width p-button-secondary',
            icon: 'icons8-diviser-cellules',
            disabled: false,
        });
    }
}

export function setBtGridAction(aFromBsk, aDelBsk, aRightService, aSrchMode, aBtGridActionList, self) {
    let wLabel = self.translate.instant('Add_Bask');
    let wIcon = 'icons8-add-basket';
    let wClass = 'margin cust-width';
    if (aSrchMode === reqBas) {
        wLabel = self.translate.instant('Del_Bask');
        wIcon = 'icons8-trash-can';
        wClass = 'margin cust-width p-button-danger';
    }
    if (aRightService.actionDisplay.TPan ) {
        aBtGridActionList.push({
            call: self.goAddBasket.bind(self),
            pTooltip: wLabel,
            class: wClass,
            icon: wIcon,
            disabled: false,
        });
    }

    if (self.bskMode === false) {
        if (aRightService.actionDisplay.TMov ) {
            aBtGridActionList.push({
                call: self.goOnMoveDoc.bind(self),
                pTooltip: self.translate.instant('Move'),
                class: 'margin cust-width',
                icon: 'icons8-partager-3-2',
                disabled: false,
            });
        }
    }

    if (aRightService.menuItem.TExp) {
        aBtGridActionList.push({
            call: self.goClickExport.bind(self),
            pTooltip: self.translate.instant('Export'),
            class: 'margin cust-width',
            icon: 'icons8-exporter',
            disabled: false,
        });
        aBtGridActionList.push({
            call: self.goClickExportXlsx.bind(self),
            pTooltip: self.translate.instant('Export_Xlsx'),
            class: 'margin cust-width btn-excel',
            icon: 'pi pi-file-excel',
            disabled: false,
        });
    }

    if (aRightService.menuItem.TStat && aSrchMode !== reqBas) {
        if (aRightService.actionDisplay.TStat ) {
            aBtGridActionList.push({
                call: self.goClickStat.bind(self),
                pTooltip: self.translate.instant('Stat'),
                class: 'margin cust-width',
                icon: 'icons8-statistiques',
                disabled: false,
            });
        }
    }

    if (aRightService.actionDisplay.TMail ) {
        aBtGridActionList.push({
            call: self.goClickSendMail.bind(self),
            pTooltip: self.translate.instant('Send_Email'),
            class: 'margin cust-width',
            icon: 'icons8-envoyer-des-email-de-masse',
            disabled: false,
        });
    }    

   
    if (aRightService.menuItem.TRBsk) {
        if (aFromBsk) {
            if (self.basketMoveAll.length !== 0) {
                setTransBsk(aBtGridActionList, self);
            }
        } else {
            if (aRightService.actionDisplay.TRBsk ) {
                setTransBsk(aBtGridActionList, self);
            }
        }
    }

    if (aDelBsk === true && aSrchMode !== reqBas) {
        let wLabel: string;
        if (aFromBsk) {
            wLabel = self.translate.instant('Del_Bsk');
            setDelBsk(wLabel, aBtGridActionList, self);
        } else {
            if (aRightService.actionDisplay.TDel ) {
                wLabel = self.translate.instant('Del_Ged');
                setDelBsk(wLabel, aBtGridActionList, self);
            }
        }
    }
}

export function setDelBsk(aLabel, aBtGridActionList, self) {
    aBtGridActionList.push({
        call: self.goClickDelBsk.bind(self),
        pTooltip: aLabel,
        class: 'margin cust-width p-button-danger',
        icon: 'icons8-trash-can',
        disabled: false,
    });
}

export function setTransBsk(aBtGridActionList, self) {
    aBtGridActionList.push({
        call: self.goClickTransBsk.bind(self),
        pTooltip: self.translate.instant('Tr_Bsk'),
        class: 'margin cust-width',
        icon: 'icons8-send-package-2',
        disabled: false,
    });
}

export function setMenuImageGed(aRightService, aMenuImage, self) {
    let wStamp = {
        Text: self.translate.instant('Ent_Data'),
        Variable: 'Ask',
    };
    AddTextPdf(aMenuImage, self);
    if (aRightService.typeAction.TPost) {
        addAnnot(aMenuImage, self);
    }
    if (aRightService.typeAction.TSign) {
        addGraphSign(aMenuImage, self);
    }
    if (aRightService.typeAction.TStamp) {
        addStamp(wStamp, aMenuImage, self);
    }
}

export function isLock(aCurrentUser, aLockUser) {
    if (aLockUser === '') {
        return false;
    } else {
        if (aCurrentUser === aLockUser) {
            return false;
        } else {
            return true;
        }
    }
}

export function gethasLock(resultDisplay) {
    let wRes = false;
    let wCheckoutuser = '';
    for (const item of resultDisplay) {
        wCheckoutuser = returnEmpty(item.doc_checkoutuser);
        if (wCheckoutuser !== '') {
            wRes = true;
            break;
        }
    }
    return wRes;
}

export function updateAtf(aAction, aValue) {
    let wValue = 0;
    let wRes = '0';
    wValue = parseInt(aValue);
    if (aAction === 'add') {
        wValue++;
    } else {
        wValue--;
    }
    wRes = wValue.toString();
    return wRes;
}

